import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { useNavigate, useParams } from "react-router-dom";
import { OverAllTrackEnumValue, TaskStatusEnumValue } from "@backend/src/schemas/enums";
import ReactDOMServer from "react-dom/server";
import { useTranslation } from "react-i18next";
// export type chartDataType = { value: number; name: string }
export type ChartProps = {
  chartData: {
    value: number; name: string; subText?: string;
}[];
  color: string[];
  title: string;
  subtext?: string;
  radius: string[];
  height: string;
  hoverText?:string
};
interface PieChartProps {
  chartProps: ChartProps;
}
const PieChart: React.FC<PieChartProps> = ({ chartProps }) => {
  const projectId = useParams()?.projectId;
  const navigate = useNavigate();
  const filterRoutes = (key: string, item: string) => {
    navigate(`/tasks/${projectId}?view=LIST&${key}=${item}`);
  };
  const { t } = useTranslation();
  const chartref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const myChart = echarts.init(chartref.current as HTMLDivElement);
    const option: echarts.EChartsOption = {
      color: chartProps?.color,
      title: {
        text: chartProps?.title,
        subtext: chartProps?.subtext,
        left: "center",
        top:"1%",
        textStyle: { color: "#000000" },
      },
      tooltip: {
        trigger: "item",
        formatter: (a: any) => {
          return ReactDOMServer.renderToString(
            <div className="flex flex-col items-center">
              <span className="inline bg-slate-50/50 !rounded-md">
                {a.percent.toFixed()}% {a.name}
              </span>
              {a.data.subText && (
                <div className="inline bg-slate-50/50 !rounded-md text-xs">
                  ({a.data.subText})
                </div>
              )}
            </div>
          );
        },
      },
      legend: {
        bottom: "0%",
        left: "center",
        textStyle: {
          fontSize: 12,
          fontWeight: "normal",
          color: "#000000",
        },
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: chartProps?.radius,
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: "inner",
            formatter: "{c} ",
            fontSize: 14,
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 20,
              fontWeight: "bolder",
            },
          },
          labelLine: {
            show: false,
          },
          data: chartProps?.chartData,
        },
      ],
    };

    myChart.on("click", (params: any) => {
      if (projectId) {
        if (
          Object.keys(TaskStatusEnumValue).find(
            (d) => t(d) == params.name.toUpperCase().replace(/\s/g, "_") || t(d) == params.name
          )
        ) {
          filterRoutes(
            "status",
            params.name == t("IN_PROGRESS")
              ? "IN_PROGRESS"
              : params.name == t("NOT_STARTED")
                ? "NOT_STARTED"
                : "COMPLETED"
          );
        } else {
          filterRoutes(
            "flag",
            params.name == t("SIGNIFICANT_DELAY")
              ? "Red"
              : params.name == t("MODERATE_DELAY")
              ? "Orange"
              : params.name == t("AHEAD_OF_SCHEDULE")
              ? "Green"
              : params.name == t("ON_TIME")
              ? "Green"
              : ""
          );
        }
      }else{
        if(Object.values(OverAllTrackEnumValue).some(o =>t(o) == params.name)){
          navigate(`/projects?overall=${Object.values(OverAllTrackEnumValue).find(o =>t(o) == params.name)}`);
        }
        
        if(["SIGNIFICANT_BUDGET",
          "MODERATE_BUDGET",
          "ON_BUDGET",
          "UNDER_BUDGET"].some(o =>t(o) == params.name)){
          navigate(`/projects?budget=${["SIGNIFICANT_BUDGET",
            "MODERATE_BUDGET",
            "ON_BUDGET",
            "UNDER_BUDGET"].find(o =>t(o) == params.name)}`);
        }
        if( ["Significant delay", "On time", "Moderate delay","Ahead Of Schedule"].map(t=>t.toUpperCase().replaceAll(" ","_")).some(o =>t(o) == params.name)){
          navigate(`/projects?delay=${["Significant delay", "On time", "Moderate delay","Ahead Of Schedule"].map(t=>t.toUpperCase().replaceAll(" ","_")).find(o =>t(o) == params.name)}`);
        }
      }
    });
    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [chartProps]);

  return (
    <div ref={chartref} style={{ width: "100%", height: chartProps?.height }} />
  );
};
export default PieChart;
